import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import { ReactComponent as EyeIcon } from "../../../asset/icons/eyeIcon.svg";
import { useTranslation } from "react-i18next";
import DBInput from "../../../component/global/DBInput";
import DBFieldBlock from "../../../component/global/DBFieldBlock";
import DBButton from "../../../component/global/DBButton";
import { useRequest } from "./../../../hooks/helperData/useRequest";
import { ToastContext } from "../../../component/global/ToastContext";
import { CHANGE_PASS } from "../../../helperData/ApiAddress";

export default function User({ data }) {
    const initFormData = {
        username: data.username,
        oldPass: "",
        newPass: "",
        newPass2: "",
    };

    const { t } = useTranslation();
    const [formData, setFormData] = useState(initFormData);
    const [formErr, setFormErr] = useState({
        oldPass: "",
        newPass: "",
        newPass2: "",
    });

    const toast = useContext(ToastContext);

    const [submitReq, submitLoader] = useRequest(CHANGE_PASS, "POST");

    const submitForm = () => {
        let tempErr = formErr;

        if (formData.oldPass.trim() === "") {
            tempErr = {
                ...tempErr,
                oldPass: t("Src.Pages.UserPages.UserProfile.User.passwordErr"),
            };
        }

        if (formData.newPass.trim() === "") {
            tempErr = {
                ...tempErr,
                newPass: t("Src.Pages.UserPages.UserProfile.User.passwordErr"),
            };
        }

        if (formData.newPass2.trim() === "") {
            tempErr = {
                ...tempErr,
                newPass2: t("Src.Pages.UserPages.UserProfile.User.passwordErr"),
            };
        }

        if (formData.newPass !== formData.newPass2) {
            tempErr = {
                ...tempErr,
                newPass2: t(
                    "Src.Pages.UserPages.UserProfile.User.passwordErr.match"
                ),
            };
        }

        if (Object.keys(tempErr).some((item) => tempErr[item].length > 0)) {
            setFormErr(tempErr);
            return false;
        }

        submitReq({
            old_password: formData.oldPass,
            new_password: formData.newPass,
        })
            .then(() => {
                toast(
                    t("Src.Pages.UserPages.UserProfile.User.password.success"),
                    "success"
                );
                setFormData(initFormData);
            })
            .catch((e) => {
                if (e.response?.data.detail === "the password is wrong") {
                    toast(
                        t(
                            "Src.Pages.UserPages.UserProfile.User.password.wrong"
                        ),
                        "danger"
                    );
                } else {
                    toast(
                        t(
                            "Src.Pages.UserPages.UserProfile.User.password.error"
                        ),
                        "danger"
                    );
                }
            });
    };

    return (
        <div className="page-load-fade">
            <div className="general-info-form">
                <DBFieldBlock
                    title={t(
                        "UserPanel.Profile.UserInfo.Username.Place.Holder"
                    )}
                    required
                >
                    <DBInput
                        type="text"
                        value={formData.username.replace("+98", "0")}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                username: e.target.value,
                            });
                        }}
                        size="large"
                        readOnly
                    />
                </DBFieldBlock>
                <DBFieldBlock
                    title={t(
                        "UserPanel.Profile.UserInfo.OldPassword.Place.Holder"
                    )}
                    required
                    error={formErr.oldPass}
                >
                    <DBInput.Password
                        type="password"
                        value={formData.oldPass}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                oldPass: e.target.value,
                            });
                        }}
                        status={formErr.oldPass && "error"}
                        size="large"
                        onFocus={() => setFormErr({ ...formErr, oldPass: "" })}
                        onClick={() => setFormErr({ ...formErr, oldPass: "" })}
                    />
                </DBFieldBlock>
                <DBFieldBlock
                    title={t(
                        "UserPanel.Profile.UserInfo.NewPassword.Place.Holder"
                    )}
                    required
                    error={formErr.newPass}
                >
                    <DBInput.Password
                        type="password"
                        value={formData.newPass}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                newPass: e.target.value,
                            });
                        }}
                        onFocus={() => setFormErr({ ...formErr, newPass: "" })}
                        onClick={() => setFormErr({ ...formErr, newPass: "" })}
                        status={formErr.newPass && "error"}
                        size="large"
                    />
                </DBFieldBlock>
                <DBFieldBlock
                    title={t(
                        "UserPanel.Profile.UserInfo.NewpasswordRepitition.Place.Holder"
                    )}
                    required
                    error={formErr.newPass2}
                >
                    <DBInput.Password
                        value={formData.newPass2}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                newPass2: e.target.value,
                            });
                        }}
                        onFocus={() => setFormErr({ ...formErr, newPass2: "" })}
                        onClick={() => setFormErr({ ...formErr, newPass2: "" })}
                        status={formErr.newPass2 && "error"}
                        size="large"
                    />
                </DBFieldBlock>
                <DBButton
                    onClick={submitForm}
                    className="user-submit-button"
                    caption={t("UserPanel.Profile.UserInfo.SaveChanges.Button")}
                />
            </div>
        </div>
    );
}
